<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: WangYuan
 * @LastEditTime: 2025-05-26
-->
<template>
  <config-wrap :title="label">
    <div class="select" v-if="mValue.isNeedCom != false">
      <ul class="select-label">
        <li class="select-label-text">支持点位链接</li>
      </ul>
      <div class="select-body">
        <el-switch v-model="mValue.supportLink"></el-switch>
      </div>
    </div>

    <div class="select" v-if="mValue.isNeedCom != false">
      <ul class="select-label">
        <li class="select-label-text">标签分组吸顶</li>
      </ul>
      <div class="select-body">
        <div
            class="mode-select-item flex-center"
            v-for="(item, index) in doTopModelList"
            :key="index"
            :class="[mValue.doTopModel == item.value ? 'mode-select-item-active' : '']"
            @click="clickItem(item.value, 'doTopModel')"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>

    <div class="select" v-if="mValue.isNeedCom != false">
      <ul class="select-label">
        <li class="select-label-text">显示全部分组</li>
      </ul>
      <div class="select-body">
        <div
            class="mode-select-item flex-center"
            v-for="(item, index) in groupModelList"
            :key="index"
            :class="[mValue.groupModel == item.value ? 'mode-select-item-active' : '']"
            @click="clickItem(item.value, 'groupModel')"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>

    <div class="select" v-if="mValue.isNeedCom != false">
      <ul class="select-label">
        <li class="select-label-text">标签分组设置</li>
      </ul>
      <div class="select-body" style="flex: 1">
        <el-radio
            v-model="mValue.tagGroupSet"
            @input="changeTagGroupSet"
            :label="item.value"
            v-for="(item, index) in tagGroupSetList"
            :key="index"
        >{{ item.label }}
        </el-radio>
      </div>
      <div class="btnRebset" @click="btnRebset">重置</div>
    </div>

    <div v-if="mValue.tagGroupSet == 'selfSet'">
      <div class="select">
        <ul class="select-label">
          <li class="select-label-text">内容展示方式</li>
        </ul>
        <div class="select-body">
          <el-radio
              v-model="mValue.tagShowType"
              :label="item.value"
              v-for="(item, index) in conShowType"
              :key="index"
          >
            {{ item.label }}
          </el-radio>
        </div>
      </div>
      <div style="font-size: 13px; color: red; text-align: right; line-height: 25px">
        1.单例：多个状态值的切换(同一个组件);<br />
        2.多例：多个组件的切换(不同组件);
      </div>
    </div>

    <div v-if="mValue.tagGroupSet == 'auto' || mValue.tagGroupSet == 'hand'">
      <div class="select">
        <ul class="select-label">
          <li class="select-label-text">
            {{ mValue.isNeedCom == false ? "关联类目" : "标签数据源" }}
          </li>
        </ul>
        <div class="select-body">
          <el-select v-model="mValue.tagSource" size="small" @change="changeCategory">
            <el-option
                v-for="(item, index) in tagList"
                :key="index"
                :label="item.name"
                :value="item.url"
            />
          </el-select>
        </div>
      </div>

      <div
          class="select"
          v-if="
          mValue.tagGroupSet == 'auto' &&
          mValue.showLevel != false &&
          mValue.showType == 'show_tree'
        "
      >
        <ul class="select-label">
          <li class="select-label-text">显示层级</li>
        </ul>
        <div class="select-body">
          <el-select v-model="mValue.showLevel" size="small">
            <el-option
                v-for="(item, index) in deepList"
                :key="index"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </div>
      </div>

      <div class="select" v-if="mValue.isNeedCom != false">
        <ul class="select-label">
          <li class="select-label-text">关联组件</li>
        </ul>
        <div class="select-body">
          <el-select
              style="z-index:0"
              v-model="mValue.components"
              placeholder="请选择"
              size="small"
              multiple
          >
            <el-option
                v-for="(item, index) in curPage.componentEntityList"
                :key="item.id + '-' + item.component"
                :label="
                item.name && curPage.componentEntityList[0].component != 'navTop'
                  ? index + 2 + '-' + item.name
                  : item.name && curPage.componentEntityList[0].component == 'navTop'
                  ? index + 1 + '-' + item.name
                  : !item.name && curPage.componentEntityList[0].component != 'navTop'
                  ? index + 2 + '-' + '-顶部导航'
                  : index + 1 + '-顶部导航'
              "
                :value="item.id + '-' + item.component"
                :disabled="item.component == 'navTop' || item.id == control.curWidget.id"
            >
              {{
                item.component == "navTop" || item.id == control.curWidget.id
                    ? ""
                    : curPage.componentEntityList[0].component != "navTop"
                        ? index + 2 + "-" + item.name
                        : index + 1 + "-" + item.name
              }}
            </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="groupSet mt20" v-if="mValue.tagGroupSet == 'hand'">
      <div class="zidong">
        <el-tag
            class="mr10 mb10"
            v-for="(item, index) in mValue.categoryList"
            :key="index"
            :closable="item[mValue.showName] != '全部' ? true : false"
            @close="handleClose(item)"
        >
          {{ item[mValue.showName] }}
        </el-tag>
      </div>
    </div>

    <div
        class="mt20 addGroup"
        @click="btnShowGroup"
        v-show="mValue.tagGroupSet == 'hand'"
    >
      添加分组
    </div>

    <div class="mt20 addGroup mb20" @click="btnAddGroup" v-if="mValue.isNeedCom != false">
      添加自定义分组
    </div>

    <div v-if="mValue.selfCategory.length > 0">

      <div
          v-for="(item, index) in mValue.selfCategory"
          :key="index"
          style="position: relative"
          class="self mb20"
      >
        <div class="close" @click="btnDel(index)">
          <span class="iconfont icon-guanbi"></span>
        </div>

        <div class="self-con mb10">
          <div class="mt10 mr10" style="padding-left: 24px">类型:</div>
          <div style="flex: 1; margin-top: 10px">
            <el-radio
                v-model="item.btnType"
                :label="itemss.value"
                v-for="(itemss, index) in conButtonType"
                :key="itemss.value"
            >
              {{ itemss.label }}
            </el-radio>
          </div>
        </div>

        <div class="self-con mb10">
          <div class="mt10 mr10">分组名称:</div>
          <div style="flex: 1">
            <el-input
                type="text"
                placeholder="请输入分组名称"
                v-model="item.name"
                size="small"
            ></el-input>
          </div>
        </div>

        <div class="self-con mb10">
          <div class="mt10 mr10">显示条件:</div>
          <div style="flex: 1">
            <el-input
                type="text"
                placeholder="不配置则全显示"
                v-model="item.showCondition"
                size="small"
            ></el-input>
          </div>
        </div>

        <div class="self-con mb10">
          <div class="mt10 mr10" style="font-size: 12px">关联组件:</div>
          <div style="flex: 1">
            <el-select
                v-model="item.components"
                placeholder="请选择"
                size="small"
                clearable
                @change="btnSwitchCom($event, index)"
                multiple
            >
              <el-option
                  v-for="(item, index1) in curPage.componentEntityList"
                  :key="item.id + '-' + item.component"
                  :label="
                  item.name && curPage.componentEntityList[0].component != 'navTop'
                    ? index1 + 2 + '-' + item.name
                    : item.name && curPage.componentEntityList[0].component == 'navTop'
                    ? index1 + 1 + '-' + item.name
                    : !item.name && curPage.componentEntityList[0].component != 'navTop'
                    ? index1 + 2 + '-' + '-顶部导航'
                    : index1 + 1 + '-顶部导航'
                "
                  :value="item.id + '-' + item.component"
                  :disabled="disabled(item, index)"
              >
                {{
                  item.component == "navTop" || item.id == control.curWidget.id
                      ? ""
                      : curPage.componentEntityList[0].component != "navTop"
                          ? index1 + 2 + "-" + item.name
                          : index1 + 1 + "-" + item.name
                }}
              </el-option>
            </el-select>
          </div>
        </div>

        <div v-show="item.btnType != 'hoverButton'">
          <div class="self-con mb10">
            <div class="mt10 mr10">参数名字:</div>
            <div style="flex: 1">
              <el-input
                  type="text"
                  placeholder="请输入参数名字"
                  v-model="item.signSelfSetChinaName"
                  size="small"
              ></el-input>
            </div>
          </div>
          <div class="self-con mb10">
            <div class="mt10 mr10">参数属性:</div>
            <div style="flex: 1">
              <el-input
                  type="text"
                  placeholder="请输入参数属性"
                  v-model="item.sign"
                  size="small"
              ></el-input>
            </div>
          </div>
          <div class="self-con mb10">
            <div class="mt10 mr10" style="padding-left: 12px">参数值:</div>
            <div style="flex: 1">
              <el-input
                  type="text"
                  placeholder="请输入参数值"
                  v-model="item.value"
                  size="small"
              ></el-input>
            </div>
          </div>
        </div>

        <div v-show="item.btnType && item.btnType == 'hoverButton'">
          <div class="self-con mb10">
            <div class="mt10 mr10">展现形式:</div>
            <div style="flex: 1; margin-top: 10px">
              <el-radio
                  v-model="item.showType"
                  :label="itemss.value"
                  v-for="(itemss, index) in conShowTypeList"
                  :key="itemss.value"
              >
                {{ itemss.label }}
              </el-radio>
            </div>
          </div>
          <div class="self-con mb10">
            <div class="mt10 mr10">选择tab配置:</div>
            <div style="flex: 1; margin-top: 10px">
              <el-select
                  placeholder="请选择"
                  size="small"
                  v-model="item.tabOptionId"
                  @change="changeTabSource($event, item, index)"
              >
                <el-option
                    v-for="(itemss, index) in sourceList"
                    :key="index"
                    :value="itemss.tabOptionId"
                    :label="itemss.name"
                >
                  {{ itemss.name }}
                </el-option>
              </el-select>
            </div>
          </div>
          <div
              v-show="item.tabOptionId"
              style="background: #f5f5f5; padding: 20px; border-radius: 5px"
          >
            <div
                class="self-con mb10"
                v-for="(itemss, index) in item.jsontext"
                :key="index"
            >
              <div class="mt10 mr10">{{ itemss.name }}:</div>
              <div style="flex: 1; margin-top: 10px">
                <el-select
                    placeholder="请选择"
                    size="small"
                    multiple
                    v-model="itemss.sign"
                >
                  <el-option
                      v-for="(itemsss, index) in item.paramsData"
                      :key="index"
                      :value="itemsss.source"
                      :label="itemsss.sourceName"
                  >
                    {{ itemsss.sourceName }}
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="select" v-if="mValue.isNeedCom == false">
      <ul class="select-label">
        <li class="select-label-text">{{ mValue.title }}</li>
      </ul>
      <div class="select-body">
        <el-button @click="openCategoryModal" size="mini" type="primary">
          选择分类
        </el-button>
      </div>
    </div>

    <el-dialog
        v-if="showCategoryModal"
        title="选择分类"
        :visible.sync="showCategoryModal"
        width="30%"
    >
      <div>
        <div
            style="
            border: 1px solid rgba(228, 228, 228, 1);
            height: 400px;
            overflow-x: hidden;
            overflow-y: auto;padding: 10px 0;
          "
        >
          <el-tree
              ref="categoryTree"
              :data="categoryList"
              show-checkbox
              check-on-click-node
              default-expand-all
              :node-key="mValue.clickId"
              highlight-current
              max-height="500"
              :props="{
              children: mValue.children,
              label: 'name',
            }"
              @check="(node, checkedNode) => handleCategoryCheck(node, checkedNode)"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <div>
                <i
                    :style="categoryTreeSelect.includes(data[mValue.clickValue]) ? 'color:#1684FC' : ''"
                    v-if="data.children && data.children.length > 0"
                    class="el-icon-folder-opened mr10"
                ></i>
                <i
                    v-else
                    :style="categoryTreeSelect.includes(data[mValue.clickValue]) ? 'color:#1684FC' : ''"
                    class="el-icon-document mr10"
                ></i>
                <span
                    :style="categoryTreeSelect.includes(data[mValue.clickValue]) ? 'color:#1684FC' : ''"
                >{{ node.label }}</span>
              </div>
            </span>
          </el-tree>
        </div>
        <div slot="footer" style="text-align: right;margin-top: 20px;">
          <el-button size="small" @click="showCategoryModal = false">取 消</el-button>
          <el-button size="small" type="primary" @click="showCategoryModal = false">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-if="show" title="信息分组" :visible.sync="show" width="30%">
      <div>
        <div
            style="
            border: 1px solid rgba(228, 228, 228, 1);
            height: 400px;
            overflow-x: hidden;
            overflow-y: auto;
          "
        >
          <el-tree
              ref="tree"
              :data="categoryList"
              show-checkbox
              check-strictly
              check-on-click-node
              default-expand-all
              :node-key="mValue.clickId"
              highlight-current
              :props="{
              children: mValue.children,
              label: 'name',
            }"
              @check="(node, checkedNode) => handleCheckChange(node, checkedNode)"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <div>
                <i
                    :style="checkObjs.includes(data[mValue.clickId]) ? 'color:#1684FC' : ''"
                    v-if="data.children && data.children.length > 0"
                    class="el-icon-folder-opened mr10"
                ></i>
                <i
                    v-else
                    :style="checkObjs.includes(data[mValue.clickId]) ? 'color:#1684FC' : ''"
                    class="el-icon-document mr10"
                ></i>
                <span
                    :style="checkObjs.includes(data[mValue.clickId]) ? 'color:#1684FC' : ''"
                >{{ node.label }}</span>
              </div>
            </span>
          </el-tree>
        </div>
        <div slot="footer" class="dialog-footer mt20" style="text-align: center">
          <el-button type="primary" @click="submit">确 定 </el-button>
        </div>
      </div>
    </el-dialog>
  </config-wrap>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import typeToComponent from "@/config/schema-template";
import {
  comDSList,
  getCategoryList,
  getDatasourceList,
  getRuleList,
  tabOptionPage,
} from "../../api/easyApp";
import { mapGetters, mapMutations } from "vuex";
import { deepClone } from "../../js/utils";

export default {
  name: "SchemaTagGroup",
  mixins: [schemaMixin],
  props: {
    label: { type: String, default: "" },
    edit: { type: Boolean, default: false },
    schema: { type: Object, default: () => {} },
    tagCategory: { type: String, default: "" },
    value: { type: Object, default: {} },
  },
  inject: ["control"],
  data() {
    return {
      typeToComponent,
      tagList: [],
      curTagInfo: {},
      doTopModelList: [
        { label: "吸顶", value: true },
        { label: "不吸顶", value: false },
      ],
      groupModelList: [
        { label: "显示", value: true },
        { label: "不显示", value: false },
      ],
      deepList: [
        { label: "一级", value: "1" },
        { label: "二级", value: "2" },
        { label: "三级", value: "3" },
      ],
      tagGroupSetList: [
        { label: "自动", value: "auto" },
        { label: "手动", value: "hand" },
      ],
      conShowType: [
        { label: "单例", value: "single" },
        { label: "多例", value: "multiple" },
      ],
      conButtonType: [
        { label: "普通按钮", value: "defaultButton" },
        { label: "悬浮按钮", value: "hoverButton" },
      ],
      conShowTypeList: [
        { label: "顶部弹出", value: "topProup" },
        { label: "底部弹出", value: "bottomProup" },
      ],
      curTagList: [],
      ruleList: [],
      showName: "",
      clickId: "",
      curTag: "",
      categoryList: [],
      show: false,
      checkObjs: [],
      selfCategory: [],
      decRule: [],
      pkId: "",
      pkName: "",
      children: "children",
      sourceList: [],
      showCategoryModal: false,
      categoryTreeSelect: [],
    };
  },
  computed: {
    ...mapGetters(["project", "curPage", "control"]),
  },
  async created() {
    let params = { current: 1, size: 100, type: 0 };
    let resRes = await tabOptionPage(params);
    let records = resRes.data.records || [];

    const safeParse = (val) => {
      console.log("val:",val);


      if (!val) return [];




      if (typeof val === "object") return val;
      try {
        const cleanStr = val.replace(/[\n\r\t]/g, "").trim();
        return JSON.parse(cleanStr);
      } catch (e) {
        console.warn("JSON 解析失败，已修复", e);
        return [];
      }
    };

    records.forEach(item => {
      console.log("item.jsontext:",item.jsontext);
      item.jsontext = safeParse(item.jsontext);
    });


    this.sourceList = records;

    let res1 = await getRuleList([this.tagCategory]);
    this.decRule = safeParse(res1.data?.[0]?.ruleData);

    let clickIndex = this.decRule.findIndex(item => item.pk === true);
    let showNameIndex = this.decRule.findIndex(item => !item.pk);
    if (clickIndex !== -1) this.pkId = this.decRule[clickIndex].sign;
    if (showNameIndex !== -1) this.pkName = this.decRule[showNameIndex].sign;

    let data = { tags: this.tagCategory };
    let res = await getDatasourceList(data);
    this.tagList = res.data || [];

    try {
      let index = this.tagList.findIndex(item =>
          item.url.indexOf("study/classification/tree") !== -1
      );
      if (index !== -1) {
        this.tagList[index].url += "?type=1";
      }
    } catch (e) {}

    if (this.mValue.tagSource && this.mValue.tagGroupSet !== "selfSet") {
      this.changeCategory(this.mValue.tagSource, "true");
    }
  },
  methods: {
    ...mapMutations(["setProject", "setCurPage"]),
    handleCheckChange(data) { this.select(data); },
    disabled(item) {
      return item.id === this.control.curWidget.id || item.component === "navTop";
    },
    isCanChooseCom() { return false; },
    cellClass(row) {
      if (row.columnIndex === 0) return "disabledCheck";
    },
    select(row) {
      const index = this.mValue.categoryList.findIndex(
          item => item[this.mValue.clickId] == row[this.mValue.clickId]
      );
      if (index !== -1) {
        this.checkObjs = this.checkObjs.filter(i => i != row[this.mValue.clickId]);
        this.mValue.categoryList.splice(index, 1);
      } else {
        this.checkObjs.push(row[this.mValue.clickId]);
        this.mValue.categoryList.push(row);
      }
    },
    async changeCategory(val, isStart) {
      let data = { url: val };
      let res = await getCategoryList(data);
      if (isStart !== "true") {
        this.mValue.categoryList = [];
        this.checkObjs = [];
      }

      const index = this.tagList.findIndex(i => i.url == val);
      if(index!=-1){
        this.mValue.showType=this.tagList[index].showType;


        console.log("this.tagList[index]:",this.tagList[index]);


      }

      //更改this.mValue.clickId



      this.categoryList = res.data || [];
    },
    async changeTabSource(val, item, index) {
      const idx = this.sourceList.findIndex(i => i.tabOptionId == val);


      console.log("idx:",idx);
      console.log("this.sourceList:",this.sourceList);


      if (idx !== -1) {
        this.mValue.selfCategory[index].jsontext = this.sourceList[idx].jsontext;
      }



    },
    submit() { this.show = false; },
    btnShowGroup() {
      this.show = true;
      this.$nextTick(() => {
        if (this.$refs.tree) this.$refs.tree.setCheckedKeys(this.checkObjs);
      });
    },
    btnAddGroup() {
      this.mValue.selfCategory.push({
        name: "", components: "", paramsData: [], signSelfSetChinaName: "",
        sign: "", value: "", btnType: "normal", showType: "selectHover",
        tabOptionId: "", jsontext: [], showCondition: ""
      });
      this.$message.success("添加成功");
    },
    btnSwitchCom(e, index) {
      let paramsData = [];
      try {

        e.forEach(idStr => {
          let cid = idStr.split("-")[0];
          let com = this.curPage.componentEntityList.find(x => x.id == cid);

          console.log("com?.attrs?.dataSource:",com?.attrs?.dataSource);

          if (com?.attrs?.dataSource?.paramsData) {
            paramsData = paramsData.concat(deepClone(com.attrs.dataSource.paramsData));
          }


        });
      } catch (e) {}
      this.mValue.selfCategory[index].paramsData = deepClone(paramsData);
    },
    btnDel(index) {
      this.mValue.selfCategory.splice(index, 1);
      this.$forceUpdate();
    },
    handleClose(row) {
      const idx = this.mValue.categoryList.findIndex(
          i => i[this.mValue.clickId] == row[this.mValue.clickId]
      );
      if (idx !== -1) {
        this.checkObjs = this.checkObjs.filter(i => i != row[this.mValue.clickId]);
        this.mValue.categoryList.splice(idx, 1);
      }
    },
    isCanChoose() { return false; },
    changeTagGroupSet() {},
    btnRebset() { this.mValue.tagGroupSet = ""; },
    clickItem(value, cate) {
      if (cate === "doTopModel") this.mValue.doTopModel = value;
      else this.mValue.groupModel = value;
    },
    openCategoryModal() {
      this.showCategoryModal = true;
      if (this.mValue.clickValue) {
        this.categoryTreeSelect = this.mValue.clickValue.split(",");
      }
      this.$nextTick(() => {
        if (this.$refs.categoryTree) {
          this.$refs.categoryTree.setCheckedKeys(this.categoryTreeSelect);
        }
      });
    },
    handleCategoryCheck(data, checkedNode) {
      this.mValue.clickValue = checkedNode.checkedKeys.join(",");
      this.categoryTreeSelect = checkedNode.checkedKeys;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/variable";

@font-face {
  font-family: "iconfont";
  src: url("//at.alicdn.com/t/c/font_3877952_xe4i8qzkq1.woff2") format("woff2"),
  url("//at.alicdn.com/t/c/font_3877952_xe4i8qzkq1.woff") format("woff"),
  url("//at.alicdn.com/t/c/font_3877952_xe4i8qzkq1.ttf") format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-guanbi:before { content: "\e672"; }

.el-select-dropdown__item.is-disabled { height: 0 !important; }
::v-deep .p10 { padding: 0 10px !important; }
::v-deep .config-item { margin-bottom: 1px !important; padding: 0; }

.select {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #fff;
  .select-label {
    display: flex;
    align-items: center;
    .select-label-text {
      width: 90px;
      color: #969799;
      font-size: 13px;
    }
  }
  .select-body { display: flex; flex-wrap: wrap; }
}

.mode-select-item {
  padding: 8px 10px;
  min-width: 55px;
  border: 1px solid #dcdee0;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
}
.mode-select-item-active {
  color: #1684FC;
  border-color: #1684FC;
  background: #e0edff;
}

.zidong-con {
  border: 2px dashed #cccccc;
  padding: 10px 0;
  border-radius: 5px;
  color: #666;
  font-size: 14px;
}

.addGroup {
  padding: 15px;
  border: 2px dashed #409fee;
  border-radius: 4px;
  text-align: center;
  color: #409fee;
  cursor: pointer;
}

::v-deep .el-table .disabledCheck .cell .el-checkbox__inner { display: none; }

.self {
  padding: 15px;
  border: 1px solid #ededed;
  border-radius: 5px;
  position: relative;
}
.self-con {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #969799;
}
.close {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  color: #fff;
  background: red;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
}
.btnRebset {
  color: #409fee;
  cursor: pointer;
}
</style>